// Konfigurasi URL Webhook Discord untuk masing-masing channel
const WEBHOOKS = {
  WORKSPACE: "https://discord.com/api/webhooks/1509052924708257873/-MhEaLuYzyqAEEoS8c6-A94TpI4UPIlIGfRMGuz-uJuQDepaPoDhI7pHxAnfv-3I_bup",
  PRODUKSI: "https://discord.com/api/webhooks/1509053429505458178/kUJ-fgqZQNL-DYFnfSLLoUL6jfiULo2ucpqyoXBPdYV3kjf7Q_XYRP5CiJlbYXdddk3K",
  FINANCE: "https://discord.com/api/webhooks/1509053552578793554/GGoSbVAnuH0cYZ_0ZJEfPp11XpPWAb84uSFRRPcp1EaQIxiQwzL97JCrSI8VhKcE7nQz",
  MARKETING: "https://discord.com/api/webhooks/1509053698804813844/ZpPg79ZP4DAmyIUx4iQgSY_YrfgUswaIrPC1k7EHNPc3jezueKt9ItMBIXD6e0pwHrt5",
  LANDING_PAGE: "https://discord.com/api/webhooks/1509053798314934363/tpLKgmD4f6Gjjh8Qs1vWnTSHkXxHb_FTrjk5yKVzhRqHyzzBCzbH35KgmUYvY5AOTRam"
};

/**
 * Mengirim pesan Rich Embed ke Discord via Webhook.
 * 
 * @param {string} channel - Key channel ('WORKSPACE', 'PRODUKSI', dll)
 * @param {string} title - Judul embed
 * @param {string} message - Isi pesan dari ASA
 * @param {string} colorHex - Warna garis embed (misal: "#D4AF37")
 * @param {Object} author - Info user yang terdeteksi (nama, role)
 */
export async function sendDiscordReport(channel = 'WORKSPACE', title, message, colorHex = '#D4AF37', author = null) {
  const url = WEBHOOKS[channel] || WEBHOOKS.WORKSPACE;
  
  // Konversi warna hex ke decimal (Discord API constraint)
  const colorDecimal = parseInt(colorHex.replace('#', ''), 16);

  const embed = {
    title: title,
    description: message,
    color: colorDecimal,
    timestamp: new Date().toISOString(),
    footer: {
      text: "Satala ASA Intelligence System"
    }
  };

  if (author) {
    embed.author = {
      name: `User: ${author.name || 'Unknown'} (${author.role || 'staf'})`
    };
  }

  const payload = {
    username: "ASA Intelligence",
    avatar_url: "https://cdn.discordapp.com/attachments/123/456/asa_sparkles.png", // Akan fallback ke default kalau mati
    embeds: [embed]
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      console.warn("Gagal mengirim ke Discord:", response.statusText);
    }
  } catch (error) {
    console.error("Discord Webhook Error:", error);
  }
}
